import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// components
import Header from "./headerComponent/header";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Landing from "./pages/Landing";
import Footer from "./footerComponent/footer";
import Graphics from "./pages/Graphics";
import Web from "./pages/Web";
import Coding from "./pages/Coding";
import Photography from "./pages/Photography";
import HatchwayPractice from "./pages/hatchway-practice/HatchwayPractice";

// routes to a specific page
import * as ROUTES from "../constants/routes";

// includes
const App = () => {
  return (
    <Router>
      <div className="App">
        <Header />

        <Switch>
          <Route exact path={ROUTES.LANDING} render={() => <Landing />} />

          <Route path="/portfolio" render={() => <Portfolio />} />
          <Route path="/about" render={() => <About />} />
          <Route path="/contact" render={() => <Contact />} />

          <Route path="/graphics" render={() => <Graphics />} />
          <Route path="/web" render={() => <Web />} />
          <Route path="/coding" render={() => <Coding />} />
          <Route path="/photography" render={() => <Photography />} />
          <Route
            path="/hatchway-practice"
            render={() => <HatchwayPractice />}
          />
        </Switch>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
